$w.onReady(async function () {
	$w('#dividerBox').collapse();
});


$widget.onPropsChanged(async (oldProps, newProps) => {
	try {
		if (!newProps.data) return;

		const data = JSON.parse(newProps.data);
		const dividerSection = data.section;

		console.log("Divider section:", dividerSection);

		setDividerSection(dividerSection);	
	} catch (error) {
		console.log('Error in Divider onPropsChanged function:', error);
	}
});


export function setDividerSection(dividerSection) {
	try {
		if (!dividerSection) {
			console.log("No Divider section found");
			return;
		}

		if (!dividerSection.isVisible) {
			console.log("Divider section isVisible is set to false");
			return;			
		}

		$w('#dividerBox').expand();
	} catch (error) {
		console.log('Error in setDividerSection function:', error);
	}
}